import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useAppDispatch } from '../../hooks/useAppDipatch';
import type { NavigationItem } from './DesktopNav';
import { useNavigate } from 'react-router-dom';
import { setCreationStep } from '../../features/campaigns/campaignsSlice';
import { FairdayLogo } from '../Brand/FairdayLogo';

interface MobileNavigationProps {
  items: NavigationItem[];
  currentTab: string;
}

export default function MobileNav({ items, currentTab }: MobileNavigationProps) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="flex items-center justify-between p-4 lg:hidden glass-panel">
        <div className="flex items-center">
          <FairdayLogo className="h-[60px] w-auto" color="white" />
        </div>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="p-2 rounded-lg hover:bg-brand-hover transition-colors"
        >
          {isOpen ? (
            <X className="h-6 w-6 text-text-muted" />
          ) : (
            <Menu className="h-6 w-6 text-text-muted" />
          )}
        </button>
      </div>

      {isOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div
            className="fixed inset-0 bg-black/50 backdrop-blur-sm"
            onClick={() => setIsOpen(false)}
          />
          <div className="fixed inset-y-0 left-0 w-64 glass-panel p-4">
            <div className="flex items-center justify-between mb-8">
              <div className="flex items-center">
                <FairdayLogo className="h-[60px] w-auto" color="white" />
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="p-2 rounded-lg hover:bg-brand-hover transition-colors"
              >
                <X className="h-6 w-6 text-text-muted" />
              </button>
            </div>
            <div className="space-y-1">
              {items.map((item) => (
                <button
                  key={item.label}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${
                    currentTab === item.id
                      ? 'bg-accent/10 text-accent'
                      : 'text-neutral-light hover:bg-brand-hover'
                  }`}
                  onClick={() => {
                    navigate(item.href);
                    if (item.id === 'campaigns') {
                      dispatch(setCreationStep('none'));
                    }
                  }}
                >
                  <div className={currentTab === item.id ? 'text-accent' : 'text-text-muted'}>
                    {item.icon}
                  </div>
                  <span className="font-medium">{item.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
